import { render, staticRenderFns } from "./DynamicModalComponent.vue?vue&type=template&id=3195f5ea&"
import script from "./DynamicModalComponent.vue?vue&type=script&lang=js&"
export * from "./DynamicModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports